import { h } from 'preact';
export const MoreHorizontal = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("circle", { cx: "12", cy: "12", r: "1" }),
        h("circle", { cx: "19", cy: "12", r: "1" }),
        h("circle", { cx: "5", cy: "12", r: "1" })));
};
//# sourceMappingURL=more-horizontal.js.map